import { render } from "./AdminHome.vue?vue&type=template&id=49fbfc4c&scoped=true"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"

import "./AdminHome.vue?vue&type=style&index=0&id=49fbfc4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fbfc4c"]])

export default __exports__